import { render } from "./Error404.vue?vue&type=template&id=0149a8f3"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/error/Error404.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0149a8f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0149a8f3', __exports__)) {
    api.reload('0149a8f3', __exports__)
  }
  
  module.hot.accept("./Error404.vue?vue&type=template&id=0149a8f3", () => {
    api.rerender('0149a8f3', render)
  })

}


export default __exports__